import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

export interface DocumentDetailsResponse {
  tid: string;
  title: string;
  name: string;
  field_airport_codes: string;
  field_airport_ranking: string;
  field_airport_contact_name: string;
  field_airport_contact_number: string;
  createdAt: string;
  updatedAt: string;
  status: boolean;
  published: boolean;
  id: string;
  field_airport_name_en: string;
  field_airport_name_ms: string;
  field_airport_name_zh: string;
}

// edit api call
const fetchAirportDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanCMSApi.get(`/api/airport/get-all/${id}`);

  return response?.data[0];
};

const useAirportDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["airportDocumentDetails", id],
      queryFn: () => {
        return fetchAirportDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useAirportDocumentDetails };
